import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "Na"; // Na stands for need assistance
const NaActions = actionNameGenerator(domainPrefix);

export const submitNeedAssistanceDataType = NaActions(
  "submitNeedAssistanceData"
);
export const showAssistanceComponentType = NaActions("showAssistanceComponent");
export const showAssistanceDoneType = NaActions("showAssistanceDone");
export const fetchDataSuccessType = NaActions("fetchDataSuccess");
export const fetchDataFailureType = NaActions("fetchDataFailure");
export const showNaDrawerType = NaActions("showNaDrawer");
export const submissionDoneType = NaActions("submissionDone");
